import React from 'react';

const ViewAllRoyaltyReport = (props) => {
    return (
        <div>
            ViewAllRoyaltyReport
        </div>
    );
};

export default ViewAllRoyaltyReport;
